import {doc, getFirestore, onSnapshot} from "firebase/firestore";
import {useEffect, useState} from "react";

export default function DmDiscounts(props){
    const db=getFirestore();
    const [discounts,setDiscounts]= useState([]);

    useEffect(async()=>{

        const unsubscribe= onSnapshot(doc(db,"celebrities",props.id),(doc)=>{
            var data= doc.data();

            var discounts=data["videoRequest"]["promos"];
            setDiscounts([...discounts]);
        })

        return function(){
            unsubscribe();
        }


    },[]);



    return(
        <div className="h-96 w-full bg-white/50 overflow-scroll flex-col p-3 rounded">
            <div className="h-24 w-full bg-black mb-2 text-white flex justify-start items-center flex-row p-3  overflow-x-scoll">


                <div className="pl-5 w-1/4">
                    PromoTitle
                </div>

                <div className="pl-5 w-32 overflow-scroll">
                    PromoCode
                </div>
                <div className="pl-5 w-32 overflow-scroll">
                    Discount
                </div>
                <div className="pl-5 w-32">
                    Total Promo Codes
                </div>
                <div className="pl-5 w-32">
                    Expiry Date
                </div>


            </div>
            {
                discounts.map((discountData,index)=>{
                    return(

                        <div className="h-24 w-full bg-black mb-2 text-white flex justify-start items-center flex-row p-3  overflow-x-scoll">



                            <div className="pl-5 w-1/4">
                                {discountData["promoTitle"]}
                            </div>

                            <div className="pl-5 w-32 overflow-scroll">
                                {discountData["promoCode"]}
                            </div>
                            <div className="pl-5 w-32 overflow-scroll">
                                {discountData["promoDiscount"]}%
                            </div>
                            <div className="pl-5 w-32">
                                {discountData["totalPromoCodes"]}
                            </div>
                            <div className="pl-5 w-32">
                                {discountData["expiry"].toDate().getDate().toString()}-{(discountData["expiry"].toDate().getMonth()+1).toString()}-{discountData["expiry"].toDate().getFullYear().toString()}
                            </div>

                        </div>

                    )
                })
            }

        </div>
    )
}